import { bootstrapWidget } from "./core/bootstrap/bootstrap-widget.ts";
import {
  getBrowserHostname,
  getCurrentScriptElement,
} from "./core/bootstrap/bootstrap-source.ts";
import { getOrCreateWidgetRoot } from "./core/dom/widget-root.ts";
import { createWidgetStore } from "./core/state/widget-store.ts";
import { mountWidgetShell } from "./modules/shell/widget-shell.ts";

export const widgetStore = createWidgetStore();

export async function startWidget() {
  const scriptElement = getCurrentScriptElement();
  const root = getOrCreateWidgetRoot();

  const result = await bootstrapWidget({
    env: import.meta.env,
    hostname: getBrowserHostname(),
    root: root.mountRoot,
    scriptElement,
    store: widgetStore,
  });

  if (result.ok) {
    try {
      mountWidgetShell({
        config: result.config,
        mountRoot: root.mountRoot,
      });
    } catch {
      root.mountRoot.replaceChildren();
      widgetStore.setFailed("shell-render-failed");
    }
  }

  return result;
}

void startWidget();
